export class UrlService {
    public static serializeObjectToQueryString(obj: Record<string, string | FormDataEntryValue>): string {
        const searchParams = new URLSearchParams();

        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                const value = obj[key];
                searchParams.append(key, value as string);
            }
        }

        return searchParams.toString();
    }
}
